import { Dispatch, FC, SetStateAction, useState } from "react";
import { add } from "date-fns";
import { Form, Formik } from "formik";

import { SearchIcon } from "@heroicons/react/outline";
import { EmojiSadIcon } from "@heroicons/react/outline";

import "./PriceForm.css";
import Select, { SelectOption, SelectOptionGroup } from "../ui/Select";
import Button from "../ui/Button";
import DatePicker from "../ui/DatePicker";
import useConnect from "./PriceForm.connect";
import { RentalPrice } from "../../api/types";

interface Props {
  places: SelectOption[] | SelectOptionGroup[];
  pickupPlace: SelectOption | undefined;
  rentalDates: Date[] | undefined;
  setPrices: Dispatch<SetStateAction<RentalPrice[]>>;
  setOffer: Dispatch<SetStateAction<RentalPrice | undefined>>;
  setPickupPlace: Dispatch<SetStateAction<SelectOption | undefined>>;
  setRentalDates: Dispatch<SetStateAction<Date[] | undefined>>;
}
const PriceForm: FC<Props> = ({
  places,
  setPrices,
  setOffer,
  pickupPlace,
  setPickupPlace,
  rentalDates,
  setRentalDates,
}) => {
  const { noResultsFound, initialValues, validationSchema, onSubmit } =
    useConnect(
      setPrices,
      setOffer,
      pickupPlace,
      setPickupPlace,
      rentalDates,
      setRentalDates
    );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => onSubmit(values)}
    >
      {({ errors, isSubmitting, setFieldValue, values, isValid }) => {
        return (
          <Form>
            <div className="tw-form-wrapper">
              <div className="sm:tw-grid tw-grid-cols-12 sm:tw-space-x-2 tw-space-y-3 sm:tw-space-y-0">
                <div className="tw-col-span-6  lg:tw-col-span-7">
                  <Select
                    label={"Lugar de recogida"}
                    items={places}
                    value={values.pickupPlace}
                    onChange={(e) => setFieldValue("pickupPlace", e)}
                    
                  />
                </div>
                <div className="tw-col-span-4">
                  <DatePicker
                    label={"Fechas de renta"}
                    isRange={true}
                    pages={2}
                    value={[
                      initialValues.pickupDate,
                      initialValues.dropoffDate,
                    ]}
                    minRange={5}
                    maxRange={45}
                    minDate={add(new Date(), { days: 3 })}
                    rangeStartLabel={"Recogida"}
                    rangeEndLabel={"Entrega"}
                    onChange={(e: any) => {
                      if (e.value[0]) {
                        setFieldValue("pickupDate", e.value[0]);
                      }
                      if (e.value[1]) {
                        setFieldValue("dropoffDate", e.value[1]);
                      }
                    }}
                  />
                </div>

                <div className="tw-col-span-2 lg:tw-col-span-1">
                  <Button
                    id="botonBuscarAuto"
                    topGap={true}
                    label={isSubmitting ? "Buscando" : "Buscar"}
                    disabled={isSubmitting || !isValid}
                    type="submit"
                  />
                </div>
              </div>

              {noResultsFound && (
                <div className="tw-form-no-results">
                  <EmojiSadIcon
                    className="tw-mx-auto tw-h-10 tw-w-10 tw-text-gray-400"
                    aria-hidden="true"
                  />
                  <p className="tw-mt-4 tw-font-semibold tw-text-gray-900">
                    No se han encontrado autos disponibles.
                  </p>
                  <p className="tw-mt-2 tw-text-gray-500">
                    No hemos podido encontraros autos disponible con su criterio
                    de renta. <br />
                    Intente con otro lugar de recogida o fechas de renta.
                  </p>
                </div>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PriceForm;
